import { SourceSlackChannelConfig } from 'api/model'
import { useActiveOrganization } from './use-organization'
import { useCallback, useLayoutEffect, useState } from 'react'
import { sourcesGetChannelsConfig } from 'api/endpoints/jelledFromFileSpecWithTransformer'

function useFetchChannelsConfig() {
  const [activeOrganization] = useActiveOrganization()
  const [channels, setChannels] = useState<SourceSlackChannelConfig[]>([])
  const [isFutureChannelsEnabled, setIsFutureChannelsEnabled] = useState<boolean>(false)

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetchInsightCategories = useCallback(async () => {
    if (!activeOrganization) {
      return
    }

    setIsLoading(true)

    try {
      const response = await sourcesGetChannelsConfig(activeOrganization)
      if (response.data) {
        setChannels(response.data.channels)
        setIsFutureChannelsEnabled(response.data.is_future_channels_enabled)
      }
    } catch (error) {
      setError(`${error}`)
    } finally {
      setIsLoading(false)
    }
  }, [activeOrganization])

  useLayoutEffect(() => {
    refetchInsightCategories()
  }, [refetchInsightCategories])

  return {
    isLoading,
    channels,
    error,
    isFutureChannelsEnabled,
    setIsFutureChannelsEnabled,
  }
}

export { useFetchChannelsConfig }
